<template>
	<div class="meta">
		<router-link
			to="/connection"
			tag="div"
			class="live-connection-btn"
		>
			<button-ui
				text="Connection"
				icon="dot-circle"
				small
				left
				theme="white"
			/>
		</router-link>

		<!-- Meta Content -->
		<div class="meta__content">
			<h1 
				class="meta__content--title"
				v-html="meta.title"
			/>

			<div class="meta__content--preface">
				<small class="global__label block">Preface</small> 
				<p
					v-html="meta. preface"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import meta from '@data/meta.json';
	import ButtonUi from '@/ui/components/ButtonUI';

	export default {
		components: {
			ButtonUi
		},
		computed: {
			meta() {
				return meta;
			},
		}
	};
</script>

<style lang="scss" scoped>
	.meta {
		width: 100vw;
		height: 100vh;

		display: flex;
		align-items: center;
		flex-direction: column;

		padding: 1em 1.5em 0;
		width: calc(100% - 3em);

		@include tablet {
			padding: 0em 3em;
			width: calc(100% - 6em);
		}

		@include desktop {
			max-width: 1024px;
			margin: 0 auto;
		}

		&__logo {
			max-width: 150px;
			margin: 1em 0;
			align-self: flex-start;
		}

		&__content {
			font-size: 0.9em;

			h2, h3 {
				margin: 0.15em 0;
				font-size: 1.2em;
			}

			&--title {
				font-size: 2.8em;
				margin: 1em 0;
				font-family: 'Josefin';

				/deep/ strong {
					display: block;
					font-size: 1.4em;
				}
			} 
			&--volume {
				margin: 0;
				font: {
					size: 0.7em;
				}
			}

			&--preface {
				margin: 1em auto;
				padding-bottom: 70px;
				
				@include tablet {
					font-size: 1.2em;
				}
			}
		}
	}

	.live-connection-btn {
		position: fixed;
		top: 10px;
		right: 5px;
		cursor: pointer;

		@include desktop {
			display: none;
		}
	}
</style>

